module.exports = __webpack_public_path__ + "assets/img/main_viewallnews.b0126092.svg";